export enum FeedbackDraftsActionTypes {
  ADD_FEEDBACK_DRAFT = 'feedbackDraft/ADD_FEEDBACK_DRAFT',
  REMOVE_FEEDBACK_DRAFT = 'feedbackDraft/REMOVE_FEEDBACK_DRAFT',
}

export interface IFeedbackDraftState {
  readonly feedbackDraftBySubmissionId: Record<number, string>
}
